import { createSelector } from '@ngrx/store';

import * as fromUi from '../ui.reducer';

export const selectState = createSelector(
  fromUi.selectState,
  fromUi.getToast
);

